import React, { useState } from 'react';
import { FilterItem } from "../interfaces/types";

interface SearchFilterCategoriesProps {
    filterByPageTypeLabel: string;
    searchContentType: string;
    contentTypes: FilterItem[];
    updateContentType: (checkbox: HTMLInputElement, contentType: string) => void;
}

export const SearchFilterContentType: React.FC<SearchFilterCategoriesProps> = ({ filterByPageTypeLabel, searchContentType, contentTypes, updateContentType }) => {
    const [filtersExpanded, setFiltersExpanded] = useState(true);
    return (
        <div className="search-filters-section">
            <button type="button" aria-expanded={filtersExpanded} onClick={() => {
                setFiltersExpanded(!filtersExpanded)
            }} className="search-filters-section-button">
                {filterByPageTypeLabel}
            </button>
            <div className="search-filters-section-panel" role="region" aria-hidden={!filtersExpanded}>
                <div className="search-filters-section-panel-inner">
                    <ul className="stack-sm">
                        {contentTypes.map((filter, index) => (
                            <li key={index}>
                                <input tabIndex={filtersExpanded ? null : -1} type="checkbox"
                                    checked={searchContentType.includes(filter.key)}
                                    onChange={(e) => {
                                        updateContentType(e.target as HTMLInputElement, e.target.value);
                                    }}
                                    id={`searchContentTypeCheckbox_${index}`} value={filter.key} />
                                <label htmlFor={`searchContentTypeCheckbox_${index}`}>
                                    {filter.value}
                                </label>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}